export default __webpack_public_path__ + "static/media/checklist.ba828365.png";